import script from "./RacingSportSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./RacingSportSlider.vue?vue&type=script&setup=true&lang=js"

import "./RacingSportSlider.vue?vue&type=style&index=0&id=45987164&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45987164"]])

export default __exports__